import ReportingProduct from "../../../components/screen/Reporting/ReportingProduct/ReportingProduct";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";
import { useNavigate } from "react-router-dom";

const ReportingProductPage = () => {
  const navigate = useNavigate();

  return (
    <div className="">
      <PageTemplate
        header="Laporan"
        mainComponent={
          <ThemeProvider theme={theme}>
            <ReportingProduct />
          </ThemeProvider>
        }
        breadcrumb={
          <div className="flex text-blue-500 gap-2 text-[12px]">
            <p
              className="hover:cursor-pointer"
              onClick={() => navigate("/inventory/produk-aktif")}
            >
              Laporan
            </p>
            <p>/</p>
            <p className="hover:cursor-pointer">Laporan Per Produk</p>
          </div>
        }
        pageRole={5}
      />
    </div>
  );
};

export default HOC(ReportingProductPage);
